module.exports = __webpack_public_path__ + "static/working-designer-3663ba664348b57e0199d76dc258be3c.png";